import { Box, Button, Drawer, Grid, Tab, Tabs, Typography } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { Filters, SIXTY_DAYS } from '../DateAndTime.helpers';
import DayFilters from '../DayFilters';
export default function FilterDrawer({
  filters,
  setOpenDrawer,
  handleDrawerClose,
  openDrawer,
  setDate,
  setThreeDaySwitch,
  date,
  threeDaySwitch,
  weekDays,
  timeOfDay,
  setTimeOfDay,
  setWeekDays,
  setFilters
}: {
  setFilters: ({
    timeOfDay,
    weekDays
  }: Filters) => void;
  filters: Filters;
  setThreeDaySwitch: (bool: boolean) => void;
  threeDaySwitch: boolean;
  setTimeOfDay: (timeOfDay: string) => void;
  setWeekDays: (weekDays: string[]) => void;
  weekDays: string[];
  timeOfDay: string;
  date: Date;
  setDate: (date: Date) => void;
  openDrawer: boolean;
  setOpenDrawer: (bool: boolean) => void;
  handleDrawerClose: () => void;
}) {
  const today = new Date();
  const [tab, setTab] = useState(0);
  const {
    t
  } = useTranslation('dateAndTime');
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };
  return <Drawer open={openDrawer} anchor="bottom" onClose={handleDrawerClose} data-sentry-element="Drawer" data-sentry-component="FilterDrawer" data-sentry-source-file="FilterDrawer.tsx">
			<Box sx={{
      borderBottom: 1,
      borderColor: 'divider'
    }} data-sentry-element="Box" data-sentry-source-file="FilterDrawer.tsx">
				<Tabs value={tab} onChange={handleTabChange} centered variant="fullWidth" sx={{
        '.MuiTabs-indicator': {
          bgcolor: 'secondary.main'
        }
      }} data-sentry-element="Tabs" data-sentry-source-file="FilterDrawer.tsx">
					<Tab label={<Typography color="secondary.main" variant="bodyMediumBook">
								{t('calendar')}
							</Typography>} data-sentry-element="Tab" data-sentry-source-file="FilterDrawer.tsx" />
					<Tab label={<Typography data-test-id="filter-message" color="secondary.main" variant="bodyMediumBook">
								{t('filter')}
							</Typography>} data-sentry-element="Tab" data-sentry-source-file="FilterDrawer.tsx" />
				</Tabs>
			</Box>
			<CustomTabPanel value={tab} index={0} data-sentry-element="CustomTabPanel" data-sentry-source-file="FilterDrawer.tsx">
				<StaticDatePicker value={date} minDate={new Date()} maxDate={new Date(today.setDate(today.getDate() + SIXTY_DAYS))} shouldDisableDate={date => date.getDay() === 0} onChange={newValue => {
        setDate(newValue ?? new Date());
        setThreeDaySwitch(false);
      }} slotProps={{
        toolbar: {
          hidden: true
        },
        actionBar: {
          actions: []
        }
      }} onAccept={() => setOpenDrawer(false)} views={['day']} data-sentry-element="StaticDatePicker" data-sentry-source-file="FilterDrawer.tsx" />
			</CustomTabPanel>
			<CustomTabPanel value={tab} index={1} data-sentry-element="CustomTabPanel" data-sentry-source-file="FilterDrawer.tsx">
				<DayFilters threeDaySwitch={threeDaySwitch} timeOfDay={timeOfDay} setTimeOfDay={setTimeOfDay} weekDays={weekDays} setWeekDays={setWeekDays} data-sentry-element="DayFilters" data-sentry-source-file="FilterDrawer.tsx" />
			</CustomTabPanel>
			<Grid container justifyContent="space-between" data-sentry-element="Grid" data-sentry-source-file="FilterDrawer.tsx">
				<Grid data-sentry-element="Grid" data-sentry-source-file="FilterDrawer.tsx">
					<Button size="M" onClick={() => {
          setDate(new Date());
          setTimeOfDay('');
          setWeekDays([]);
        }} sx={{
          textTransform: 'none'
        }} data-sentry-element="Button" data-sentry-source-file="FilterDrawer.tsx">
						<Typography color="primary.main" variant="buttonLabel" data-sentry-element="Typography" data-sentry-source-file="FilterDrawer.tsx">
							{t('reset')}
						</Typography>
					</Button>
				</Grid>

				<Grid data-sentry-element="Grid" data-sentry-source-file="FilterDrawer.tsx">
					<Button size="M" onClick={() => {
          setTimeOfDay(filters.timeOfDay ?? '');
          setWeekDays(filters.weekDays ?? []);
          handleDrawerClose();
        }} sx={{
          textTransform: 'none'
        }} data-sentry-element="Button" data-sentry-source-file="FilterDrawer.tsx">
						<Typography color="primary.main" variant="buttonLabel" data-sentry-element="Typography" data-sentry-source-file="FilterDrawer.tsx">
							{t('cancel')}
						</Typography>
					</Button>
					<Button variant="tertiaryDefault" size="M" onClick={() => {
          setThreeDaySwitch(false);
          setFilters({
            weekDays,
            timeOfDay
          });
          handleDrawerClose();
        }} data-sentry-element="Button" data-sentry-source-file="FilterDrawer.tsx">
						{t('apply')}
					</Button>
				</Grid>
			</Grid>
		</Drawer>;
}
function CustomTabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other} data-sentry-component="CustomTabPanel" data-sentry-source-file="FilterDrawer.tsx">
			{value === index && <Box sx={{
      p: 3
    }}>{children}</Box>}
		</div>;
}